import { useDocsLayoutStore } from '@/business-components/docs-layout/store/docsLayoutStore';
import { NavbarGroup } from '@/business-components/navbar-group/NavbarGroup';
import usePersistFn from '@/hooks/usePersistFn';
import { useAppearanceConfigModelStore } from '@/models/appearance-config/appearanceConfig';
import { GlobalClassName } from '@/shared/constant/GlobalClassName';
import clsx from 'clsx';
import type { useLevelNavbarGroup } from '../../hooks/useLevelNavbarGroup';

export type MoreLevelNavbarContentProps = {
  secondLevelNavbarGroup: ReturnType<typeof useLevelNavbarGroup>['secondLevelNavbarGroup'];
  thirdLevelNavbarGroup: ReturnType<typeof useLevelNavbarGroup>['thirdLevelNavbarGroup'];
  className?: string;
};

export function MoreLevelNavbarContent(props: MoreLevelNavbarContentProps) {
  const { className, secondLevelNavbarGroup, thirdLevelNavbarGroup } = props;

  const isOpenDebugPanel = useAppearanceConfigModelStore((x) => x.isOpenDebugPanel);
  const setOpenDrawer = useDocsLayoutStore((x) => x.setOpenDrawer);
  const hiddenDrawer = usePersistFn(() => {
    setOpenDrawer(false);
  });

  if (!secondLevelNavbarGroup && !thirdLevelNavbarGroup) {
    return null;
  }
  return (
    <div
      className={clsx(
        {
          [GlobalClassName.HeaderSecondlyNavbar]: !thirdLevelNavbarGroup,
          [GlobalClassName.HeaderTertiaryNavbar]: thirdLevelNavbarGroup,
        },
        'hidden os:flex os:justify-center os:py-1.5',
        className,
      )}
    >
      <div
        className={clsx('hidden h-9 items-center px-5 os:flex os:w-0 os:flex-1 os:px-8', {
          ['os:max-w-[1560px]']: !isOpenDebugPanel,
          ['os:max-w-[1800px]']: isOpenDebugPanel,
        })}
      >
        {secondLevelNavbarGroup && (
          <NavbarGroup
            {...secondLevelNavbarGroup}
            className={clsx({
              ['os:w-0 os:flex-1']: !thirdLevelNavbarGroup,
            })}
            onClick={hiddenDrawer}
          />
        )}
        {secondLevelNavbarGroup && thirdLevelNavbarGroup && (
          <div className="mx-3 hidden h-3 border-l os:block" />
        )}
        {thirdLevelNavbarGroup && (
          <NavbarGroup {...thirdLevelNavbarGroup} className="w-0 flex-1" onClick={hiddenDrawer} />
        )}
      </div>
    </div>
  );
}
